module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Impressão de Relatórios'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-mask ng-valid-maxlength ng-valid-minlength ng-valid-max ng-valid-date ng-valid ng-valid-required",
    attrs: {
      "name": "frmRegNotice",
      "novalidate": "",
      "_lpchecked": "1"
    }
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "control-label col-md-2",
    attrs: {
      "for": "projetos"
    }
  }, [_vm._v("Relatório:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.relatorio),
      expression: "relatorio"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "name": "relatorio"
    },
    on: {
      "click": function($event) {
        _vm.show = true
      },
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.relatorio = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.campo]
    }
  }, _vm._l((_vm.relatorios), function(relatorio) {
    return _c('option', {
      domProps: {
        "value": relatorio
      }
    }, [_vm._v(_vm._s(relatorio.ds_codigo + ' - ' + relatorio.ds_titulo))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "box box-widget"
  }, [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(this.usuarioLogado.userType === 'FUNDACAO') ? _c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.relatorioForm), function(item) {
    return _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-sm-2"
    }, [_vm._v(_vm._s(item.ds_titulo) + ":")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.value),
        expression: "item.value"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "required": "",
        "name": item.ds_codigo
      },
      domProps: {
        "value": (item.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.valores[item.ds_codigo]))])])])
  }), 0) : _vm._e(), _vm._v(" "), (this.usuarioLogado.userType === 'ENTIDADE') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group required",
    attrs: {
      "disabled": _vm.trava === 1
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto),
      expression: "projeto"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "projeto",
      "disabled": _vm.carregou !== 1,
      "aria-hidden": "true"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeProjeto(_vm.projeto)
      }]
    }
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto
      }
    }, [_vm._v(_vm._s(projeto.ds_codigo_projeto_erp) + " - " + _vm._s(projeto.ds_nome))])
  }), 0), _vm._v(" "), (_vm.carregou !== 1) ? _c('div', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando listagem de projetos....\n                                ")]) : _vm._e()])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "href": "javascript:void(0)"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onLoad($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Emitir Relatório")])], 1)])])])])])])])]), _vm._v(" "), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Relatórios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-ds_titulo"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Impressão de Relatórios")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "box-ds_titulo"
  }, [_c('b', [_vm._v("Campos do Relatório: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label col-xs-4 col-sm-3 col-lg-2",
    attrs: {
      "for": "projeto"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Projeto:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e9cd6586!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relatorioserp/EmiteRelatorioERP.vue
// module id = 1975
// module chunks = 2